<template>
  <div class="customized_report">
    <img class="bg_img" src="../../../static/imgs/VXImage/bg_img.svg" />
    <div class="content flex_column">
      <div class="introduce_img flex_column">
        <img
          class="button"
          @click="custom()"
          src="../../../static/imgs/VXImage/button_icon.svg"
        />
        <img
          class="content_img"
          style="margin-bottom: 26px"
          src="../../../static/imgs/VXImage/content_img1.svg"
        />
        <img
          class="content_img"
          style="margin-bottom: 33px"
          src="../../../static/imgs/VXImage/content_img2.svg"
        />
        <img
          class="content_img"
          style="margin-bottom: 29px"
          src="../../../static/imgs/VXImage/content_img3.svg"
        />
        <img
          class="content_img"
          style="margin-bottom: 36px"
          src="../../../static/imgs/VXImage/content_img4.svg"
        />
        <div class="swiper">
          <img
            class="content_img"
            style="margin-bottom: 28px"
            src="../../../static/imgs/VXImage/content_img5.svg"
          />
          <div class="client_box flex_column">
            <img src="../../../static/imgs/VXImage/client_img1.svg" />
            <span>了解更多案例 马上联系客户经理</span>
          </div>
        </div>
        <img
          class="button"
          @click="custom()"
          src="../../../static/imgs/VXImage/button_icon.svg"
        />
        <div class="QRcode_box flex_column">
          <img
            class="content_img"
            src="../../../static/imgs/VXImage/QRcode_bg.svg"
          />
          <img class="QRcode" src="../../../static/imgs/VXImage/QRcode.svg" />
        </div>
      </div>
      <div class="exceed_box flex_column">
        <img
          class="title_img"
          src="../../../static/imgs/VXImage/title_img1.svg"
        />
        <div class="text">
          <p>40年前你要是会开车，你就算有了一个铁饭碗；</p>
          <p>30年前如果你去学了英语和计算机，如今的你一定是个高薪人才；</p>
          <p>20年前如果你抓住了淘宝电商商机，现在的你或许已身家过亿；</p>
          <p>10年前如果你就紧跟跨境浪潮，现在的你想必早已财务自由</p>
        </div>
        <div class="key_words">而现在，新机会模式依然在……</div>
        <img
          class="title_img"
          src="../../../static/imgs/VXImage/title_img2.svg"
        />
        <div class="introduce_list">
          <div class="li">
            <span>100万+<br />跨境电商客户</span>
            <img src="../../../static/imgs/VXImage/introduce_icon1.svg" />
          </div>
          <div class="li">
            <span>170+<br />客户来源国家</span>
            <img src="../../../static/imgs/VXImage/introduce_icon2.svg" />
          </div>
          <div class="li">
            <span>近十亿美金<br />GMV</span>
            <img src="../../../static/imgs/VXImage/introduce_icon3.svg" />
          </div>
          <div class="li">
            <span>全球最先进<br />跨境出海智能<br />解决方案</span>
            <img src="../../../static/imgs/VXImage/introduce_icon4.svg" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "customizedReport",
  data() {
    return {};
  },
  methods: {
    custom() {
      this.$router.push({
        path: `privateReport`,
      });
    },
  },
  created() {},
};
</script>
<style scoped>
.customized_report {
  width: 100%;
  max-width: 640px;
  margin: 0 auto;
  position: relative;
  background: #0360d6;
  overflow: hidden;
}
.bg_img {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.content {
  width: 100%;
  /* position: absolute;
  top: 12.3%; */
  margin-top: 5.85rem;
}
.content .button {
  width: 70%;
  z-index: 1;
}
.introduce_img {
  padding: 0 .15rem;
  z-index: 1;
}
.content .content_img {
  width: 100%;
}
.content .swiper {
  position: relative;
}
.content .swiper .client_box {
  position: absolute;
  top: 16%;
  width: 100%;
  padding: 0 10%;
}
.content .swiper .client_box img {
  width: 100%;
}
.content .swiper .client_box span {
  font-family: SourceHanSansCN-Medium;
  font-size: 0.2rem;
  color: #1b63ee;
  letter-spacing: 0.46px;
  line-height: 24px;
  font-weight: 500;
  margin-top: 10px;
}
.QRcode_box {
  position: relative;
}
.QRcode_box .content_img {
  margin-top: -15%;
  width: 100%;
}
.QRcode_box .QRcode {
  width: 35%;
  position: absolute;
  top: 15%;
  z-index: 1;
}
.exceed_box {
  background: #0360d6;
  padding: 0 .15rem;
  z-index: 1;
}
.title_img {
  width: 50%;
  margin-top: 40px;
}
.text {
  font-family: SourceHanSansCN-Bold;
  font-size: 0.22rem;
  color: #ffffff;
  letter-spacing: 0.62px;
  text-align: center;
  line-height: 0.4rem;
  font-weight: 700;
  margin: 20px 0 27px 0;
}
.key_words {
  font-family: AlimamaShuHeiTi-Bold;
  font-size: 0.4rem;
  color: #ffc57e;
  letter-spacing: 1.47px;
  text-align: center;
  font-weight: 700;
}
.introduce_list {
  display: flex;
  flex-wrap: wrap;
  row-gap: .2rem;
  column-gap: .25rem;
  margin-top: 35px;
  padding-bottom: 50px;
}
.introduce_list .li {
  min-width: 40%;
  /* min-width: 175px; */
  flex: 1;
  background: rgba(235, 245, 255, 0.42);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 15px;
  min-height: 88px;
}
.introduce_list .li span {
  font-family: SourceHanSansCN-Bold;
  font-size: 0.24rem;
  color: #ffffff;
  letter-spacing: 0.72px;
  line-height: 0.4rem;
  font-weight: 700;
}
.introduce_list .li img {
  width: 30%;
  margin-left: 10px;
}
.flex_column {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/VXPublicAcount/customizedReport.vue